exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".BlueprintPanelFooter {\n  border-top: 1px solid #cccccc;\n  padding: 30px 60px 10px;\n  margin: 0 -20px;\n  width: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/blocks/BlueprintPanelFooter.scss
// module id = 534
// module chunks = 0